import type { QueryClient } from "@tanstack/react-query";
import { clear } from "./session";
import { SITE_SETTINGS_KEY } from "./siteSettings";

/** The part of react-router's `navigate` a sign-out needs, so tests can fake it. */
type GoTo = (to: string, options: { replace: boolean }) => void;

/**
 * End the session: drop the tokens, drop everything the account was shown, and
 * return to the public home page — the front door, not the sign-in form —
 * replacing the page signed out from so Back does not step into it.
 *
 * The cache sweep is the half that is easy to miss. `useSession` is
 * `enabled: !!idToken`, but a disabled query still serves its cache entry, and
 * the header stays mounted across the navigation — so without this the Admin
 * link outlives the token, and the next account to sign in inherits the last
 * one's role for as long as `staleTime` holds. Everything goes except the site
 * branding, which is identical for every visitor and headlines the page being
 * landed on; clearing it would flash the app's default name over an
 * organization's own. Anything else added later is cleared by default, which is
 * the safe direction: the cost is one refetch.
 *
 * `session.clear()` deliberately stays navigation-free — a refresh that fails in
 * the background should not yank someone off the page they are reading.
 */
export function signOut(queryClient: QueryClient, navigate: GoTo): void {
  clear();
  queryClient.removeQueries({ predicate: (q) => q.queryKey[0] !== SITE_SETTINGS_KEY[0] });
  navigate("/", { replace: true });
}
